// graphql/queries/seatingCharts.js
import { gql } from "@apollo/client";

export const LIST_SEATING_CHARTS = gql`
  query ListSeatingCharts {
    seatingCharts {
      id
      name
      mode
      status
      sectionCount
      seatCount
      chartEventCount
      updatedAt
      publishedAt
    }
  }
`;

export const GET_SEATING_CHART = gql`
  query GetSeatingChart($id: ID!) {
    seatingChart(id: $id) {
      id
      name
      mode
      status
      version
      canvasElements
      canvasWidth
      canvasHeight
      sections {
        id
        chartId
        name
        orderIndex
        x
        y
        width
        height
        rotation
        seatCount
      }
      categories {
        id
        chartId
        name
        color
        orderIndex
        seatCount
      }
      seats {
        id
        chartId
        sectionId
        categoryId
        rowLabel
        label
        x
        y
        rotation
        metadata
      }
    }
  }
`;

export const GET_SEATING_CHART_VALIDATION = gql`
  query GetSeatingChartValidation($chartId: ID!) {
    seatingChartValidation(chartId: $chartId) {
      severity
      code
      message
      seatIds
    }
  }
`;

export const LIST_CHART_EVENTS = gql`
  query ListChartEvents($chartId: ID) {
    chartEvents(chartId: $chartId) {
      id
      name
      description
      chartId
      eventId
      eventSessionId
      eventName
      holdTtlMinutes
      createdAt
      seatCounts {
        total
        available
        held
        booked
        blocked
        orphaned
      }
    }
  }
`;

export const GET_ELIGIBLE_EVENTS_FOR_CHART_EVENT = gql`
  query EligibleEventsForChartEvent($search: String) {
    eligibleEventsForChartEvent(search: $search) {
      id
      kind
      name
      parentEventName
      startDate
    }
  }
`;

export const GET_TICKET_TYPES_FOR_CHART_EVENT = gql`
  query TicketTypesForChartEvent($chartEventId: ID!) {
    ticketTypesForChartEvent(chartEventId: $chartEventId) {
      held
      booked
      ticketType {
        id
        name
        price
        seatingChartCategories {
          id
          name
          color
        }
      }
    }
  }
`;

export const GET_CHART_EVENT_SEAT_STATUSES = gql`
  query GetChartEventSeatStatuses($chartEventId: ID!) {
    chartEventSeatStatuses(chartEventId: $chartEventId) {
      seatId
      status
      orphaned
      holdExpiresAt
      ticketTypeId
    }
  }
`;

export const GET_CHART_EVENT_CENTRIFUGO_AUTH = gql`
  query GetChartEventCentrifugoAuth($chartEventId: ID!) {
    chartEventCentrifugoAuth(chartEventId: $chartEventId) {
      channel
      token
    }
  }
`;